import { Formik } from 'formik';
import React from 'react';

import DropdownField from '@components/Form/DropdownField';
import Pill from '@components/Pill';
import useTrackEvent from '@hooks/useEventTracking';
import { ClickTarget, click } from '@tracking';
import { AutocompleteOption } from '@utils/interfaces';

import { ALL_CATEGORY, CategoriesProps } from './interface';

const Categories = ({ categories, onSelectCategory, selectedCategory }: CategoriesProps) => {
  const categoryOptions = [
    ALL_CATEGORY,
    ...categories.filter((category) => category !== ALL_CATEGORY),
  ];
  const dropdownOptions = categoryOptions.map((category) => ({
    label: category,
    value: category,
  }));
  const selectedOption =
    dropdownOptions.find((option) => option.value === selectedCategory) || dropdownOptions[0];
  const { trackEvent } = useTrackEvent();

  return (
    <>
      <div className="mt-32 flex items-center gap-16 border-0 border-b border-solid border-grayscale-beige pb-32 md:hidden">
        <span className="shrink-0 font-suisse-intl text-button-lg text-primary-black">
          Industry
        </span>
        <div className="w-full max-w-[350px]">
          <Formik
            enableReinitialize
            initialValues={{ category: selectedOption }}
            onSubmit={() => undefined}
            validateOnBlur={false}
            validateOnChange={false}
          >
            {({ setFieldValue }) => (
              <DropdownField
                className="font-suisse-intl text-form [&_div]:cursor-pointer [&_div]:text-grayscale-gray"
                isClearable={false}
                isSearchable={false}
                name="category"
                onChange={(option) => {
                  const selected = option as AutocompleteOption;
                  setFieldValue('category', selected);
                  trackEvent(
                    click({
                      clickTarget: ClickTarget.Top50InfluentialCategory,
                      clickText: selected?.value,
                    })
                  );
                  if (selected?.value) onSelectCategory(selected.value);
                }}
                options={dropdownOptions}
                placeholder="Select category"
              />
            )}
          </Formik>
        </div>
      </div>
      <div className="mt-32 hidden max-w-[760px] items-start sm:mt-48 md:flex lg:max-w-[920px]">
        <span className="mr-8 flex h-[34px] shrink-0 items-center font-suisse-intl text-button-lg text-primary-black">
          Industry
        </span>
        <div className="flex flex-wrap">
          {categoryOptions.map((category) => (
            <Pill
              isActive={selectedCategory === category}
              key={category}
              onClickCapture={() =>
                trackEvent(
                  click({ clickTarget: ClickTarget.Top50InfluentialCategory, clickText: category })
                )
              }
              onClick={() => onSelectCategory(category)}
              text={category}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default Categories;
